module.exports = __webpack_public_path__ + "static/mentor-default-f9d9bea337625a60fab402adcb9ab86c.svg";